import type { Question, QuestionStimulus, QuestionType } from '@examflow/core';

/**
 * TOEFL 考试等级 (总分0-120，每部分0-30)
 */
export enum TOEFLLevel {
  Beginner = 'beginner',
  LowBeginner = 'low-beginner',
  HighBeginner = 'high-beginner',
  LowIntermediate = 'low-intermediate',
  Intermediate = 'intermediate',
  HighIntermediate = 'high-intermediate',
  LowAdvanced = 'low-advanced',
  Advanced = 'advanced',
  HighAdvanced = 'high-advanced',
}

/**
 * TOEFL 考试部分
 */
export enum TOEFLSection {
  /** 阅读 */
  READING = 'reading',
  /** 听力 */
  LISTENING = 'listening',
  /** 口语 */
  SPEAKING = 'speaking',
  /** 写作 */
  WRITING = 'writing',
}

/**
 * TOEFL 题目扩展接口
 */
export interface TOEFLQuestion extends Question {
  /** 对应的 TOEFL 等级 */
  toeflLevel?: TOEFLLevel;
  /** 所属考试部分 */
  section?: TOEFLSection;
  /** 题目序号（在该部分中） */
  orderInSection?: number;
}

/**
 * TOEFL 听力题目（single_choice + audio stimulus）
 */
export interface TOEFLListeningQuestion extends TOEFLQuestion {
  type: QuestionType.SINGLE_CHOICE;
  stimulus: Extract<QuestionStimulus, 'audio'>[];
  /** 音频URL */
  audioUrl: string;
  /** 音频播放次数限制 */
  maxPlayCount?: number;
  /** 音频时长（秒） */
  audioDuration?: number;
}

/**
 * TOEFL 阅读题目（single_choice + passage stimulus）
 */
export interface TOEFLReadingQuestion extends TOEFLQuestion {
  type: QuestionType.SINGLE_CHOICE;
  stimulus: Extract<QuestionStimulus, 'passage'>[];
  /** 阅读材料 */
  passage: string;
  /** 材料来源 */
  source?: string;
}

/**
 * TOEFL 分数与等级对照表
 */
export interface TOEFLScoreMapping {
  level: TOEFLLevel;
  minScore: number;
  maxScore: number;
  cefrEquivalent: string;
  description: string;
}

/**
 * TOEFL 考试结果
 */
export interface TOEFLResult {
  /** 总分（0-120） */
  totalScore: number;
  /** 等级 */
  level: TOEFLLevel;
  /** 各部分得分（每部分0-30） */
  sectionScores: Record<TOEFLSection, number>;
  /** CEFR 等级 */
  cefrLevel: string;
  /** 详细评价 */
  evaluation: string;
}
